/**
 * POSSEN — Header search toggle.
 *
 * The search field moved out of the navigation strip and behind an icon next
 * to the account link, so the nav gets that width back. This opens it.
 *
 * Desktop only by construction: the toggle is display:none below 60rem, where
 * the bottom row becomes a drawer with its own search field. Nothing here
 * touches that field.
 *
 * Open is a click; close is Escape, a click outside, or the toggle again —
 * and focus always returns to the toggle, because a panel that steals focus
 * and does not give it back strands keyboard users mid-header.
 */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-hs-root]');
    if (!root) return;

    var toggle = document.querySelector('[data-hs-toggle]');
    var panel = root.querySelector('[data-hs-panel]');
    var input = root.querySelector('[data-hs-input]');
    if (!toggle || !panel || !input) return;

    var open = false;
    var closeTimer = null;

    function setOpen(next) {
      if (next === open) return;
      open = next;
      toggle.setAttribute('aria-expanded', String(open));

      window.clearTimeout(closeTimer);

      if (open) {
        panel.hidden = false;
        // One frame in the closed state so there is something to animate FROM;
        // without it the panel is simply there.
        void panel.offsetWidth;
        panel.setAttribute('data-state', 'open');
        input.focus();
        input.select();
      } else {
        panel.setAttribute('data-state', 'closed');
        // Keep it in the tree until the exit transition has run. The duration
        // mirrors --hs-exit; a transitionend listener would never fire under
        // prefers-reduced-motion on a property that no longer changes.
        closeTimer = window.setTimeout(function () {
          panel.hidden = true;
        }, 200);
      }
    }

    toggle.addEventListener('click', function (event) {
      event.preventDefault();
      setOpen(!open);
      if (!open) toggle.focus();
    });

    document.addEventListener('keydown', function (event) {
      if (!open || event.key !== 'Escape') return;
      event.preventDefault();
      setOpen(false);
      toggle.focus();
    });

    document.addEventListener('pointerdown', function (event) {
      if (!open) return;
      if (panel.contains(event.target) || toggle.contains(event.target)) return;
      setOpen(false);
    });

    // Tabbing past the last control in the panel means the customer is done
    // with it; leave it open only while focus is inside.
    panel.addEventListener('focusout', function (event) {
      if (!open) return;
      if (event.relatedTarget && panel.contains(event.relatedTarget)) return;
      if (event.relatedTarget === toggle) return;
      setOpen(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
